/**
 * Returns a number in Indian numbering system as a String
 *
 * @param {Number/String} number The integer to be converted.
 * @param {Number} decimals The number of digits needed after decimal point.
 * @return {String} Converted number as a String in Indian numbering unit.
 */

export const indianNSConverter = (number, decimals, recursiveCall) => {
  const decimalPoints = decimals || 2;
  const sign = Math.sign(number);
  const noOfThousands = Math.abs(number) / 1000;
  const noOfLakhs = noOfThousands / 100;
  const noOfCrores = noOfLakhs / 100;

  let displayStr;
  let isPlural;

  // Rounds off digits to decimalPoints decimal places
  function roundOf(integer) {
    if (integer) {
      return integer.toLocaleString(undefined, {
        maximumFractionDigits: decimalPoints,
      });
    }
    return integer;
  }

  if (noOfThousands < 1) { // For numbers less than thousand
    return roundOf(number);
  }
  if (noOfThousands >= 1 && noOfThousands <= 99) { // For numbers in thousands
    const thousands = roundOf(noOfThousands);
    displayStr = `${thousands * sign}k`;
  } else if (noOfLakhs >= 1 && noOfLakhs <= 99) { // For numbers in lakhs
    const lakhs = roundOf(noOfLakhs);
    isPlural = lakhs > 1 && !recursiveCall;
    displayStr = `${lakhs * sign}lac${isPlural ? "s" : ""}`;
  } else if (noOfCrores >= 1) { // For numbers in Crores
    const crores = roundOf(noOfCrores);
    const crorePrefix = noOfCrores >= 1000
      ? indianNSConverter((noOfCrores * sign), decimals, true)
      : (crores * sign);
    displayStr = `${crorePrefix}${noOfCrores >= 1000 ? " " : ""}cr`;
  } else {
    displayStr = roundOf(number);
  }

  return displayStr;
};
